import React from 'react';

import { green01, green04, greyP2, greyP3 } from '../../../theme.ts';

interface ToggleButtonProps {
  isOn: boolean;
  onToggle: () => void;
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({ isOn, onToggle }) => {
  return (
    <button
      onClick={onToggle}
      className="relative w-28 h-8 rounded-full transition-colors duration-200 ease-in-out bg-black"
    >
      <div className="absolute inset-0 flex items-center justify-between px-2">
        <div className="w-1/2 text-center">
          <span className="font-medium" style={{ color: !isOn ? greyP3 : greyP3 }}>
            No
          </span>
        </div>
        <div className="w-1/2 text-center">
          <span className="font-medium" style={{ color: isOn ? green04 : greyP3 }}>
            Yes
          </span>
        </div>
      </div>
      <div
        className={`absolute top-0.5 bottom-0.5 w-1/2 rounded-full transition-transform duration-200 ease-in-out ${
          isOn ? 'translate-x-[calc(100%-0.125em)]' : 'translate-x-0.5'
        }`}
        style={{ backgroundColor: isOn ? green01 : greyP2 }}
      >
        <div className="h-full flex items-center justify-center">
          <span className="font-medium" style={{ color: isOn ? green04 : greyP3 }}>
            {isOn ? 'Yes' : 'No'}
          </span>
        </div>
      </div>
    </button>
  );
};
